// src/components/partial-pages/VoicePage/ConfirmDeleteModal.tsx
import React, { memo } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@material-ui/core'
import { BRAND_COLOR } from 'lib/constants'

type Props = {
  open: boolean
  title: string
  message: React.ReactNode
  confirmText?: string
  cancelText?: string
  busy?: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
}

function ConfirmDeleteModal({
  open,
  title,
  message,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  busy = false,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={() => !busy && onClose()}
      fullWidth
      maxWidth="xs"
      PaperProps={{ style: { width: 420, maxWidth: '92vw' } }}
    >
      <DialogTitle style={{ fontFamily: 'Montserrat', fontWeight: 900 }}>{title}</DialogTitle>

      <DialogContent dividers>
        <div style={{ color: 'rgba(0,0,0,0.75)', fontSize: 14, lineHeight: 1.45 }}>{message}</div>
      </DialogContent>

      <DialogActions style={{ padding: '12px 16px', display: 'flex', justifyContent: 'space-between' }}>
        <Button
          variant="contained"
          disabled={busy}
          onClick={() => onConfirm()}
          style={{
            backgroundColor: busy ? undefined : BRAND_COLOR,
            color: busy ? undefined : '#fff',
            fontWeight: 900,
            textTransform: 'none',
            borderRadius: 18,
            height: 34,
            paddingLeft: 16,
            paddingRight: 16,
            minWidth: 120,
          }}
        >
          {busy ? <CircularProgress size={16} thickness={5} /> : confirmText}
        </Button>

        <Button
          onClick={() => !busy && onClose()}
          variant="outlined"
          disabled={busy}
          style={{
            borderColor: BRAND_COLOR,
            color: BRAND_COLOR,
            fontWeight: 900,
            textTransform: 'none',
            borderRadius: 18,
            height: 34,
            paddingLeft: 14,
            paddingRight: 14,
          }}
        >
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(ConfirmDeleteModal)
